export const UPLOAD_MIN_FILE_SIZE = 1; // 1 byte
export const UPLOAD_MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

export const UPLOAD_ALLOWED_CONTENT_TYPES = ["image/jpeg", "image/png", "image/webp", "image/gif"] as const;

export type UploadAllowedContentType = (typeof UPLOAD_ALLOWED_CONTENT_TYPES)[number];
